import React, { ReactNode, useMemo } from 'react';
import { EapSettingsFormModelValidationModel } from '../settings-devices-eap-settings-form.model';
import { EapSettingsFormValidationContext } from '../contexts/eap-settings-validation-form.context';

interface EapSettingsFormValidationProviderProps {
    errors?: EapSettingsFormModelValidationModel;
    children: ReactNode;
}

export const EapSettingsFormValidationProvider: React.FC<EapSettingsFormValidationProviderProps> = ({
    errors,
    children,
}) => {
    const value = useMemo(() => ({ errors }), [errors]);

    return (
        <EapSettingsFormValidationContext.Provider value={value}>{children}</EapSettingsFormValidationContext.Provider>
    );
};
